import api from '../api';

export const getBalanceRequest = country =>
  api.request({
    url: `payment/igig_balance`,
    method: 'GET',
    params: country,
  });
